export type { CoursesProps, CoursesLocaleKeys, RawEnrollment } from './types';

export { default as Courses } from './LazyCourses';
